import { StyleSheet, Font } from "@react-pdf/renderer";

Font.register({
  family: "CircularStd",
  fonts: [
    {
      src: "/CircularStd/CircularStd-Book.ttf",
    },
    {
      src: "/CircularStd/CircularStd-Bold.ttf",
      fontStyle: "normal",
      fontWeight: "bold",
    },
    {
      src: "/CircularStd/CircularStd-Black.ttf",
      fontStyle: "normal",
      fontWeight: "bolder",
    },
    {
      src: "/CircularStd/CircularStd-BoldItalic.ttf",
      fontStyle: "italic",
      fontWeight: "bold",
    },
    {
      src: "/CircularStd/CircularStd-BlackItalic.ttf",
      fontStyle: "italic",
      fontWeight: "bolder",
    },
  ],
});

export default StyleSheet.create({
  page: {
    display: "flex",
    fontFamily: "CircularStd",
  },
  section_right: {
    margin: 10,
    padding: 10,
    paddingTop: 20,
    width: "75%",
  },
  section_left: {
    width: "25%",
    height: "100%",
    backgroundColor: "#084c41",
  },
  profile_container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginTop: "20",
    marginBottom: "20px",
    height: "150",
  },
  name_text: {
    paddingTop: "10px",
    paddingBottom: "5px",
    fontSize: "14px",
    fontWeight: "900",
    color: "white",
  },
  profession_text: {
    color: "#d1d5db",
    fontSize: "11px",
  },
  profile_img: {
    width: "60px",
    height: "60px",
    borderRadius: "90",
  },
  profile_line: {
    marginTop: "10px",
    width: "10%",
    height: "1px",
    backgroundColor: "#FFF",
    textAlign: "center",
  },

  header_container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginTop: "20",
    marginBottom: "20px",
    height: "100%",
  },

  footer_container: {
    display: "flex",
    flexDirection: "column",
    position: "fixed",
    bottom: "0%",
    backgroundColor: "red",
  },

  section_top: {
    width: "100%",
    height: "100px",
  },

  logo_img_left: {
    height: "75px",
    justifyContent: "flex-start",
    paddingRight: "150px",
  },
  logo_img_right: {
    height: "75px",
    justifyContent: "flex-end",
    paddingLeft: "150px",
  },

  heading: {
    color: "#4472c4",
    fontSize: "18px",
    fontWeight: "bold",
    textAlign: "center",
    marginBottom: "10px",
  },

  subHeading: {
    fontSize: "14px",
    fontWeight: "100",
    textAlign: "center",
    marginBottom: "10px",
  },

  report_container: {
    display: "flex",
    flexDirection: "column",
    fontFamily: "CircularStd",

    paddingTop: "10px",
    paddingBottom: "10px",
    paddingRight: "20px",
    paddingLeft: "20px",
  },

  big_header: {
    backgroundColor: "#4472c4",
    color: "white",
    width: "100%",
    textAlign: "center",
    textTransform: "uppercase",
    padding: "5px",
  },
  small_header: {
    backgroundColor: "#8ea9db",
    color: "white",
    width: "100%",
    textAlign: "center",
    textTransform: "capitalize",
    padding: "5px",
  },

  employee_details: {
    display: "flex",
    flexDirection: "row",
    paddingTop: "5px",
    paddingBottom: "5px",
  },

  employee_table_left: {
    display: "flex",
    flexDirection: "column",
    flex: "3.5",
    fontSize: "12",
  },

  employee_table_right: {
    display: "flex",
    flexDirection: "column",
    flex: "1.5",
    fontSize: "12",
  },

  competency_table: {
    display: "flex",
    flexDirection: "column",
    paddingTop: "5px",
    paddingBottom: "5px",
  },

  text_box: {
    display: "flex",
    flexDirection: "column",
    paddingTop: "5px",
    paddingBottom: "5px",
  },

  text_description: {
    fontSize: "12",
  },

  grade_bar: {
    padding: "20px",
    width: "100%",
  },

  comp_container_row: {
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
    justifyContent: "center",
  },

  comp_table_long: {
    width: "100%",
    borderColor: "#e7e9eb",
    borderWidth: "2px",
    margin: "10px",
    padding: "10px",
  },

  comp_table: {
    width: "250px",
    height: "220px",
    borderColor: "#e7e9eb",
    borderWidth: "2px",
    margin: "10px",
    padding: "10px",
  },

  comp_table_header: {
    fontSize: "12px",
    fontWeight: "800",
    textAlign: "left",
    maxWidth: "90%",
    top: "-32",
  },
  comp_table_text: {
    fontSize: "10px",
    fontWeight: "200",
    top: "-15",
  },

  comp_table_divider: {
    display: "flex",
    top: "12",
    flexDirection: "row",
    width: "100%",
  },

  comp_table_divider_line: {
    height: "2px",
    width: "94%",
    textAlign: "center",
  },

  comp_table_grade_image: {
    height: "30px",
    float: "right",
    transform: "translate(0px,-15px)",
    alignContent: "flex-start",
    padding: "2px",
  },

  training_table_heading: {
    display: "flex",
    flexDirection: "row",
    borderColor: "gray",
    borderWidth: "1px",
    backgroundColor: "lightgray",
    width: "100%",
    margin: "0",
    marginTop: "10px",
    paddingBottom: "5px",
    paddingTop: "5px",
  },
  training_table_heading_left: {
    display: "flex",
    flexDirection: "column",
    flex: "2.5",
    fontSize: "12",
    paddingLeft: "10px",
  },
  training_table_heading_right: {
    display: "flex",
    flexDirection: "column",
    flex: "1.5",
    fontSize: "12",
    paddingLeft: "10px",
  },

  training_details: {
    display: "flex",
    flexDirection: "column",
    borderColor: "gray",
    borderWidth: "1px",
    margin: "0",
    marginTop: "-1px",
    marginBottom: "10px",
  },

  training_table_left: {
    display: "flex",
    flex: "2.5",
    borderRight: "1px",
    borderColor: "gray",
    paddingLeft: "10px",
    paddingRight: "10px",
  },

  training_table_right: {
    display: "flex",
    flex: "1.5",
    paddingLeft: "10px",
    paddingRight: "10px",
  },

  training_table_row: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    fontSize: "12",
  },
});
